module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//house-game_xigua.png?v=b194641f";